import { addMinutes } from 'date-fns';
import { Field, Form, Formik, useFormikContext } from 'formik';
import React, { useEffect, useState } from 'react';
import JSONPretty from 'react-json-prettify';
import { github } from 'react-json-prettify/dist/themes';
import { useDispatch, useSelector } from 'react-redux';
import { BlankTarget } from '../../components/BlankTarget';
import { Loader } from '../../components/Loader';
import { PTInputCheckboxBasic, PTInputSelect, PTInputText } from '../../components/PTElements';
import { PTCell, PTHeader, PTRowExpandable, usePTRow } from '../../components/PTRow';
import { PTTableAutoSize } from '../../components/PTTable';
import { SubmitButton } from '../../components/SubmitButton';
import { TickCross } from '../../components/TickCross';
import { logLevels } from '../../constants';
import { EVO } from '../../EVO';
import * as actions from "../../redux/clients";
import './Logs.css';

export const Logs = props => {
    const clients = useSelector(s => s.clients.clients);
    const [clientOptions, setClientOptions] = useState([]);
    const [chores, setChores] = useState([]);
    const [client, setClient] = useState({});
    const [loading, setLoading] = useState(true);
    const [choresLoading, setChoresLoading] = useState(false);
    const [logs, setLogs] = useState([]);
    const dispatch = useDispatch();

    useEffect(() => {
        dispatch(actions.fetchclients(props));
    }, []);

    useEffect(() => {
        const bob = getClientSelect(clients || []);
        if (EVO.any(bob)) {
            setLoading(false);
        }

        setClientOptions(bob);
    }, [clients]);

    const clientChange = (clientId) => {
        setChoresLoading(true);
        setLogs([]);
        setClient(clientId);
        EVO.post('/api/logs/chores', { clientId: clientId.value }).then(r => {
            if (EVO.any(r.chores)) {
                setChores(r.chores);
            }
            setChoresLoading(false);
        }).catch(e => {
            setChoresLoading(false);
        });
    };

    const submitForm = (values, { setSubmitting }) => {
        setSubmitting(true);
        setLogs([]);
        EVO.post('/api/logs', values).then(r => {
            if (EVO.any(r.logs)) {
                setLogs(r.logs);
            }
            setSubmitting(false);
        }).catch(e => {
            setSubmitting(false);
        });
    }

    useEffect(() => {
        
    }, [logs]);

    return <Loader loading={loading}>
        <div id="log-wrapper">
        <Formik
            initialValues={defaultVal}
            onSubmit={submitForm}>
            {({ isSubmitting }) =>
                <Form>
                        <div className="log-form">
                            <div>Client</div>
                            <Field name="clientId" component={PTInputSelect} options={clientOptions} onChange={clientChange} placeholder="Client" />
                            <div>Chore</div>
                            <Field name="choreId" component={PTInputSelect} options={chores} /><Loader loading={choresLoading} />
                            <div>Log Level</div>
                            <Field name="logLevel" component={PTInputSelect} options={EVO.getSelectItemFromObjectOfSelectItems(logLevels)} placeholder="Log Level" />
                            <DateRangePicker />
                            <Loader loading={isSubmitting}><SubmitButton text="Search" /></Loader>
                    </div>
                </Form>
            }
        </Formik>
            <div id="log-table-wrapper"> {EVO.any(logs) && <LogTable client={client} logs={logs} />}
        </div>
        </div>
    </Loader>
};

const LogTable = ({ client, logs }) => {
    const Header = ({ style }) => {
        return <PTHeader style={style}>
            <PTCell width={170}>Time Stamp</PTCell>
            <PTCell width={50}>Level</PTCell>
            {!client.value && <PTCell width={200}>Client</PTCell>}
            <PTCell width={200}>Chore</PTCell>
            <PTCell grow={true} shrink={true}>Message</PTCell>
            <PTCell width={50}>Extra</PTCell>
        </PTHeader>
    };

    return <PTTableAutoSize items={logs} rowSize={50} row={() => <Row client={client} />} header={Header} />
};

const Row = ({ client }) => {
    const { toggleActive, item } = usePTRow();
    return <PTRowExpandable expand={<JSONPretty json={item} theme={github} padding={4} />}>
        <PTCell width={170} onClick={() => toggleActive()}>{EVO.format(item.timeStamp, 'yyyy-MM-dd HH:mm.ss')}</PTCell>
        <PTCell width={50}><LogLevel level={item.logLevel} /></PTCell>
        {!client.value && <PTCell width={200}><BlankTarget href={`/clients/${item.clientId}`}>{item.clientName || item.clientId || ''}</BlankTarget></PTCell>}
        <PTCell width={200}><BlankTarget href={item.choreUrl}>{item.choreName}</BlankTarget></PTCell>
        <PTCell grow={true} shrink={true}>{item.message || item.rawMessage}</PTCell>
        <PTCell width={50} onClick={() => toggleActive()}><TickCross bool={item.additionalInfo} /></PTCell>
    </PTRowExpandable>
}

const LogLevel = ({ level }) => {
    return <React.Fragment>
        {level === logLevels.Error.value && <div className="log-level error"></div>}
        {level === logLevels.Info.value && <div className="log-level info"></div>}
    </React.Fragment>
};

const defaultVal = {
    clientId: '',
    choreId: '',
    from: '',
    to: '',
    fromLocal: '',
    toLocal: '',
    logLevel: '',
    timeZoneId: Intl.DateTimeFormat().resolvedOptions().timeZone,
    relativeMins: 60
};


const getClientSelect = (clients) => {
    return clients.map(c => { return { label: c.name, value: c.id }; });
};


const DateRangePicker = () => {
    const { values, setFieldValue } = useFormikContext();
    const [showAbsolute, setShowAbsolute] = useState(false);
    const [relative, setRelative] = useState(values.relativeMins);
    const [from, setFrom] = useState('');
    const [to, setTo] = useState('');

    const showAbsoluteChange = val => {
        if (val.value) {
            const actualFrom = from || addMinutes(new Date(), -values.relativeMins);
            if (!from) {
                setFrom(actualFrom);
            }

            const actualTo = to || new Date();
            if (!to) {
                setTo(actualTo);
            }

            setRelative(values.relativeMins);
            setFieldValue('from', EVO.format(EVO.localToUtc(actualFrom), "yyyy-MM-dd'T'HH:mm"));
            setFieldValue('to', EVO.format(EVO.localToUtc(actualTo), "yyyy-MM-dd'T'HH:mm"));
            setFieldValue('fromLocal', EVO.format(actualFrom, "yyyy-MM-dd'T'HH:mm"));
            setFieldValue('toLocal', EVO.format(actualTo, "yyyy-MM-dd'T'HH:mm"));
            setFieldValue('relativeMins', '');
        }
        else {
            setFieldValue('from', '');
            setFieldValue('to', '');
            setFieldValue('relativeMins', relative);
        }

        setShowAbsolute(val.value);
    };

    const updateDatTimes = (val, e) => {
        const value = EVO.format(EVO.localToUtc(val), "yyyy-MM-dd'T'HH:mm");
        setFieldValue(e.name.replaceAll('Local', ''), value);
    };


    return <div>
        {!showAbsolute && <div><div>Relative Minutes</div><Field type="number" name="relativeMins" component={PTInputText} left="true" /></div>}
        <div>
            <PTInputCheckboxBasic
                field={{ name: 'showAbsolute', value: showAbsolute }}
                onChange={e => showAbsoluteChange(e)}
                placeholder="Show Absolute"
                />
        </div>
        {showAbsolute && <div>
            <Field name="fromLocal" component={PTInputText} type="datetime-local" onChange={(val, e) => updateDatTimes(val, e)} /><span> to </span><Field name="toLocal" component={PTInputText} type="datetime-local" onChange={(val, e) => updateDatTimes(val, e)} />
        </div>}
    </div>
};




// WEBPACK FOOTER //
// ./src/pages/Logs/Logs.js